<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->
      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="loadingTable"
      >
        <loading />
      </div>

      <!-- dataTable y botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
        <!-- Botones -->
        <div style="position: relative; z-index: 5">
          <div class="d-flex" style="position: absolute">
            <!-- Modal -->
            <agregar-modulo-modal />

            <!-- Filtro -->
            <filtro-modulos />

            <!-- Modal -->
            <importar-modulos-modal />
          </div>
        </div>
        <!-- Data Table -->
        <data-table
          v-if="acciones.length > 0"
          :headers="headers"
          :data="dataTableAux"
          :acciones="acciones"
          :max="10"
          paginacion
          buscar
          idtabla="modulos"
          exportarExcel
          :seleccionar="obtenerFilaSeleccionada"
        />

        <not-found-table
          v-else
          :text="'No se encontraron registros de modulos'"
          class="justify-content-center w-100 pt-5"
        />
      </div>
    </div>

    <!-- Modales para acciones para filas -->
    <actualizar-modulo-modal :data="dataModuloActualizar" />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import DataTable from "../../common/DataTable";
import AgregarModuloModal from "../../modals/superadministrador/modulos/AgregarModuloModal";
import ActualizarModuloModal from "../../modals/superadministrador/modulos/ActualizarModuloModal";
import ImportarModulosModal from "../../modals/superadministrador/modulos/ImportarModulosModal";
import FiltroModulos from "../../filtros/superadministrador/FiltroModulos";

// Not Found
import NotFoundTable from "../../common/NotFoundTable";

// Constantes API

import {
  getModulos,
  deleteModulo,
  activarDesactivarModulo,
} from "../../../constants/superadministrador";

export default {
  props: ["data"],
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: ["Nombre", "Ícono", "Acciones"],
      acciones: [],
      dataModuloActualizar: [],
      dataTableAux: this.data,
    };
  },
  components: {
    DataTable,
    AgregarModuloModal,
    ActualizarModuloModal,
    ImportarModulosModal,
    NotFoundTable,
    FiltroModulos,
  },
  computed: {
    ...mapState(["loading", "loadingTable", "token"]),
  },
  methods: {
    ...mapActions("superadministrador", ["actionSetDataModulos"]),

    ...mapActions(["ActionSetVisibleModalEditar"]),

    async generarBotonesAcciones() {
      let me = this;

      await me.dataTableAux.map((item, index) => {
        let estado_modulo = item.data_complementaria.estado;

        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon:
              estado_modulo == 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: estado_modulo == 1 ? "Desactivar" : "Activar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    async actualizacionGenerarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataTableAux.map((item, index) => {
        let estado_modulo = item.data_complementaria.estado;

        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon:
              estado_modulo == 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: estado_modulo == 1 ? "Desactivar" : "Activar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    obtenerFilaSeleccionada(fila) {
      let textoAuxiliar = "";
      let data_fila = this.data[fila.id];
      let id_modulo = this.dataTableAux[fila.id].data_complementaria.id_modulo;
      let nombre_modulo = this.dataTableAux[fila.id].data[0];
      let estado_modulo = this.dataTableAux[fila.id].data_complementaria.estado;

      if (fila.accion == "Editar") {
        /*

        */
        this.dataModuloActualizar = data_fila;
        this.ActionSetVisibleModalEditar(true);
        /*
        /*

        */
      } else if (fila.accion == "Activar" || fila.accion == "Desactivar") {
        /*
        
        */

        if (estado_modulo == 1) {
          textoAuxiliar =
            "¿Desea desactivar el Módulo '" + nombre_modulo + "'?";
        } else {
          textoAuxiliar = "¿Desea activar el Módulo '" + nombre_modulo + "'?";
        }

        //
        this.$vToastify.prompt(textoAuxiliar).then(
          (respuesta) =>
            respuesta &&
            this.deshabilitarModulo(id_modulo, fila.accion, estado_modulo) // id, accion, estado de pallet
        );
      } else if (fila.accion == "Eliminar") {
        /*

        */
        this.$vToastify
          .prompt(`¿Desea eliminar el Módulo '${nombre_modulo}'?`)
          .then((respuesta) => respuesta && this.eliminarModulo(id_modulo));

        /*

        */
      }
    },

    async eliminarModulo(id) {
      console.log(id);
      let sql = await deleteModulo({ id });

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataModulosDB = await getModulos();

        // Actualizar los datos del dataTable
        this.actionSetDataModulos(dataModulosDB.data_table);

        this.dataTableAux = dataModulosDB.data_table;

        this.$vToastify.success(
          "Módulo eliminado correctamente",
          "¡Realizado!"
        );

        this.actualizacionGenerarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },

    async deshabilitarModulo(id, accion, estado) {
      //
      let sql = await activarDesactivarModulo({ id, estado });

      let texto = accion == "Activar" ? "activado" : "desactivado";

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataModulosDB = await getModulos();

        // Actualizar los datos del dataTable
        this.actionSetDataModulos(dataModulosDB.data_table);

        this.$vToastify.success(
          "Módulo " + texto + " correctamente",
          "¡Realizado!"
        );

        this.actualizacionGenerarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },
  watch: {
    data: function (_new) {
      let me = this;

      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        me.dataTableAux = _new;
        this.actualizacionGenerarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
